import { push, replace } from 'connected-react-router';
import { call, put, take } from 'redux-saga/effects';
import { serviceUnavailable } from '../../../modules/app/actions';
import {
  ConnectionError,
  ServiceUnavailableError,
  UnauthorizedAccessError
} from '../../../modules/app/errors';
import { restartUserJourney } from '../../../modules/auth/saga';
import { close, open } from '../../../modules/modal/actions';
import { HOME, SETTINGS } from '../../../routes/paths';
import * as notify from '../../layout/Notifications/actions';
import { CONSENTS_SAVE_REQUEST, consentsSaveFailure, consentsSaveSuccess } from './actions';
import { putConsents } from './rest';

/* eslint-disable no-constant-condition */
export default function* watchConsentsSaveRequest() {
  while (true) {
    const { consents, source } = yield take(CONSENTS_SAVE_REQUEST);
    try {
      yield put(open({ componentName: 'RequestInProgress' }));
      yield call(putConsents, consents);
      yield put(close());
      yield put(consentsSaveSuccess());
      if (source === 'login') {
        yield put(replace(HOME));
      } else {
        yield put(push(SETTINGS));
      }
    } catch (e) {
      yield put(consentsSaveFailure(e));
      yield put(close());
      if (e instanceof UnauthorizedAccessError) {
        yield call(restartUserJourney);
      } else if (e instanceof ConnectionError) {
        yield put(notify.add('Connection error.', notify.ERROR));
      } else if (e instanceof ServiceUnavailableError) {
        yield put(serviceUnavailable());
      } else {
        throw e;
      }
    }
  }
}
/* eslint-enable no-constant-condition */
